module.exports = __webpack_public_path__ + "assets/game-type-sentence-stress.ecd2d0c5.svg";